import { render, staticRenderFns } from "./ServiceFormList.vue?vue&type=template&id=16b667da&"
import script from "./ServiceFormList.vue?vue&type=script&lang=js&"
export * from "./ServiceFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports